<div *ngIf="premiumList.length > 0; else noData">
    <cpc-payment-group 
    [ngClass]="premiumList.length > 5 ? '' : 'hidden'"
    [headerColLabels]="premiumColLabels" [variant]="variant" [paymentsList]="premiumList"
        [itemsPerPage]="perPage" (clickPay)="clickPay($event)"
        copyItemPerPage="{{ 'paging.show-per-page' | translate }}" copyPrev="{{'paging.previous' | translate}}"
        copyOf="{{'paging.of' | translate}}" copyNext="{{'paging.next' | translate}}"
        copyPayNow="{{'policy.pay-now' | translate}}"></cpc-payment-group>
</div>
<ng-template #noData>
    <div class="no-data" translate>
        {{ "policy.payments.no-data-" + variant }}
    </div>
</ng-template>